import { pathFallback } from 'utils/constants';

const HTTP_PROTOCOL_PREFIX = 'http';
const HTTPS_PROTOCOL = 'https://';

export const replaceUrlFallback = url => {
  let newUrl = url;
  // TODO Remove this URL replacement when mobile app will be updated to handle new URL
  pathFallback.forEach(([replace, search]) => {
    newUrl = newUrl.replace(new RegExp(search.slice(0, -1), 'g'), replace.slice(0, -1));
  });
  return newUrl;
};

export const copyLinkInClipboard = async () => {
  await navigator.clipboard.writeText(replaceUrlFallback(window.location.href));
};

export const isValidUrl = string => {
  try {
    const url = new URL(string);
    return !!url;
  } catch (err) {
    return false;
  }
};

export const addProtocol = url => {
  if (url.indexOf(HTTP_PROTOCOL_PREFIX) === 0) {
    return url;
  }
  return `${HTTPS_PROTOCOL}${url}`;
};

export const getNormalizedUrl = url => {
  if (!url || typeof url !== 'string') return null;
  let normalizedUrl = url.trim();

  // on vérifie si c'est un email
  const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (emailPattern.test(normalizedUrl)) {
    return `mailto:${normalizedUrl}`;
  }

  // on vérifie si c'est un domaine
  const domainPattern = /^[a-z0-9.-]+\.[a-z]{2,}$/i;
  if (!/^https?:\/\//i.test(normalizedUrl)) {
    if (/^www\./i.test(normalizedUrl)) {
      normalizedUrl = `https://${normalizedUrl}`;
    } else if (domainPattern.test(normalizedUrl)) {
      normalizedUrl = `https://www.${normalizedUrl}`;
    } else {
      return null;
    }
  }

  try {
    const parsed = new URL(normalizedUrl);
    return parsed.href;
  } catch (e) {
    return null;
  }
};
